// extracted by mini-css-extract-plugin
export var divider = "_nb-0";
export var systemMessage = "_nb-1";
export var systemMessageWrapper = "_nb-2";